var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export var KeypadContext = createContext({});
export function KeypadProvider(_a) {
    var children = _a.children;
    var _b = useState(false), disableKeypadKeyboard = _b[0], setDisableKeypadKeyboard = _b[1];
    return (_jsx(KeypadContext.Provider, __assign({ value: {
            disableKeypadKeyboard: disableKeypadKeyboard,
            setDisableKeypadKeyboard: setDisableKeypadKeyboard,
        } }, { children: children })));
}
export default KeypadProvider;
export var useKeypadContext = function () {
    var context = useContext(KeypadContext);
    return context;
};
